export default __webpack_public_path__ + "static/media/PlanningToBuy.4a94194d.svg";